{
  "actions": "Działania",
  "actionsAvailable": "Dostępne działania.",
  "clearSelection": "Wyczyść zaznaczenie",
  "selected": "Zaznaczono: {count}",
  "selectedAll": "Wszystkie zaznaczone"
}
